import React from 'react';
import RecentDocuments from './RecentDocuments';

const Reports = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Reports</h1>
        <p className="text-gray-600 mt-1">View and search recent documents across all shipments</p>
      </div>
      
      <div className="grid gap-6">
        <RecentDocuments />
      </div>
    </div>
  );
};

export default Reports;
